<div class="bc-op-status js-menu-operator-status" [class.bc-op-status-loading]="isLoading$ | async">
  <app-operator-status-button *ngFor="let service of services$ | async"
                              [serviceType]="+service.serviceType"
                              [isSmsDisabled]="smsDisabled"
                              (changeStatus)="changeStatus(service.serviceType)"
  ></app-operator-status-button>
</div>
